import React, { Fragment, useState } from "react";
import { ToastContainer } from "react-toastify";
import NoPermission from "../../common/NoPermission";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import TextField from "@mui/material/TextField";
import Select from "@mui/material/Select";

const defaultValues = {
  courseType: 'none',
  year: '2022'
};

function AllPaidRegistrations({ permissions = {}, isSuperAdmin }) {
  const [showFilters, toggleFilters] = useState(true);
  const [filters, setFilters] = useState(defaultValues);
  const [isFilterSelected, setFilterSelected] = useState(false);

  const onChangeFilters = (filterName = '', value = '') => {
    let isChanged = false;
    const newFilters = { ...filters, [filterName]: value.trimStart() };
    Object.keys(defaultValues).forEach(key => {
      if (defaultValues[key] !== newFilters[key]) {
        isChanged = true;
      }
    });

    if (filterName === 'courseType') {
      newFilters['course'] = 'none';
    }

    setFilters(newFilters);
    setFilterSelected(isChanged);
  }

  const renderHeader = () => {
    return (
      <Fragment>
        <div className="section-body">
          <div className="container-fluid">
            <div className="d-flex justify-content-between align-items-center ">
              <div className="header-action">
                <h1 className="page-title">All paid registrations</h1>
                <ol className="breadcrumb page-breadcrumb">
                  <li className="breadcrumb-item">
                    <a href>St. Andrews College</a>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    All paid registrations
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  };

  const renderFilters = () => {
    return (
      <div className="accordion" id="accordionExample">
        <div className="card" style={{ borderBottom: "1px solid rgba(0,0,0,.125)" }}>
          <div className="card-header p-0" id="headingOne">
            <h2 className="mb-0 d-flex align-items-center" style={{ width: "100%" }}>
              <button className="btn btn-block text-left btn-focus" type="button" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne" onClick={() => toggleFilters(!showFilters)}>
                <h4 className="text-line pl-1">Filters</h4>
              </button>
              {showFilters ?
                <i className="fa fa-angle-up text-arrow pr-3 mb-1" style={{ cursor: "pointer" }} aria-hidden="true" onClick={() => toggleFilters(!showFilters)}></i> :
                <i className="fa fa-angle-down text-arrow pr-3 mb-1" style={{ cursor: "pointer" }} aria-hidden="true" onClick={() => toggleFilters(!showFilters)}></i>
              }
            </h2>
          </div>
          <div id="collapseOne" className={`collapse ${showFilters ? 'show' : ''}`} aria-labelledby="headingOne" data-parent="#accordionExample">
            <div className="card-body pt-0 pb-2">
              <div className="d-flex justify-content-between mb-3">
                <h6 className="mb-0">Filter By</h6>
                <div className="link" style={{ textDecoration: 'underline' }}>Reset Filters</div>
              </div>

              <div className="d-flex align-items-center pt-2 pb-2">
                <FormControl sx={{ width: 150, marginRight: 3 }} size="small">
                  <InputLabel id="demo-simple-select-label">
                    Course Type
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    label="Course Type"
                    value={filters['courseType']}
                    onChange={(e) => onChangeFilters('courseType', e.target.value)}
                  >
                    <MenuItem value="none">--Select--</MenuItem>
                    <MenuItem value="Bachelors">UG</MenuItem>
                    <MenuItem value="Masters">PG</MenuItem>
                  </Select>
                </FormControl>

                <FormControl sx={{ width: 150, marginRight: 3 }} size="small">
                  <TextField
                    id="outlined-basic"
                    label="Year"
                    variant="outlined"
                    size="small"
                    value={filters['year']}
                    onChange={(e) => onChangeFilters('year', e.target.value)} />
                </FormControl>

              </div>
              <div className="d-flex align-items-center mt-3">
                <button className="btn btn-primary" type="button">
                  Search
                </button>
              </div>
              
            </div>
          </div>
        </div>
      </div>
    );
  }

  const renderContent = () => {
    return (
      <div className="card">
        <div className="card-header">
          <h3 className="card-title">View all paid registrations</h3>
        </div>

        <div className="card-body">
          {renderFilters()}
        </div>
      </div>
    );
  };

  if (!isSuperAdmin && !permissions.read) {
    return <NoPermission />;
  }
  return (
    <Fragment>
      {renderHeader()}
      <div className="section-body mt-4">
        <div className="container-fluid">{renderContent()}</div>
      </div>
      <ToastContainer />
    </Fragment>
  );
}

export default AllPaidRegistrations;
